import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { coordinateFields } from './common/coordinateFields';
import { msg } from '@lingui/core/macro';

export const waterUsageMetadata = {
  displayName: msg({
    message: 'Water withdrawal',
    context: 'Activity data schema name for water usage',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...coordinateFields,
    ...buildingRevisionFields,
    quantity: {
      displayName: msg({
        message: 'Water used',
        context: 'The quantity of water used.',
      }),
      externalDescription: msg({
        message: 'The quantity of water used.',
        context: 'Water used',
      }),
    },
    unit: {
      displayName: msg({
        message: 'Volume unit',
        context: 'The display name for a dimension',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
